import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { BillingPaymentPaths } from '@amfam/shared/models';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { Action, DockingBarService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../core/store';

@Component({
  selector: 'app-bill-account-faq',
  templateUrl: './bill-account-faq.component.html',
  styleUrls: ['./bill-account-faq.component.scss'],
  standalone: false
})
export class BillAccountFaqComponent implements OnInit {
  isContactBillingToggleEnabled = this.featureFlagService.isEnabled('contact_billing');
  constructor(
    private dockingService: DockingBarService,
    private pageTitle: PageTitleService,
    private store: Store<fromRoot.RootState>,
    private featureFlagService: FeatureFlagService
  ) {}

  ngOnInit() {
    // @ts-ignore: TODO: Below line of code to be removed after verification
    this.isContactBillingToggleEnabled = this.dockingService.registerHeading('');
    if (this.isContactBillingToggleEnabled) {
      this.dockingService.registerAction(
        new Action('Contact Billing', () => {
          this.store.dispatch(
            fromRouterActions.Go({
              path: [BillingPaymentPaths.BILLING_CONTACT]
            })
          );
        })
      );
    }

    this.pageTitle.set('Billing & Payments - FAQ');
  }
}
